html,
body {
  scroll-behavior: smooth;
}
.header-container {
  top: 0px;
  width: 100%;
  min-width: 760px;
  height: 97px;
  background-image: url(../../assets/images/resultBackground1.png);
  background-repeat: repeat-x;
  background-size: auto 100%;
}
.indexSecond-page-container {
  width: 100%;
  min-width: 760px;
  user-select: none;
  --painting-card-container-width: 500px;
  --painting-card-width: 460px;
  --painting-card-height: 500px;
  --painting-card-image-height: 350px;
  --painting-card-padding-x: 20px;
  --painting-card-margin-y: 20px;
  --painting-card-mask-padding: 29px 20px 18px;
  --painting-card-title-font-size: 30px;
  --painting-card-title-margin-bottom: 20px;
  --painting-card-subtitle-font-size: 25px;
  --author-card-width: 300px;
  --author-card-avatar-size: 266px;
  --author-card-margin-y: 60px;
  --author-card-name-margin-top: 11px;
  --author-card-name-font-size: 30px;
  --author-card-count-font-size: 25px;
  --index-second-content-width: 1500px;
  .infotitle-container {
    font-size: 45px;
    text-align: center;
    font-weight: 900;
    margin: 135px 0 100px;
  }
  .infocontent-container {
    width: min(var(--index-second-content-width), calc(100% - 80px));
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: auto;
  }
  .end-line-container {
    margin: 150px auto 0;
    font-size: 35px;
    text-align: center;
    width: 70%;
    display: flex;
    justify-content: space-around;
    opacity: 0.5;
    .end-line {
      width: 200px;
      height: 2px;
      background-color: black;
      margin: auto;
    }
  }
}

@media (max-width: 1500px) {
  .indexSecond-page-container {
    --painting-card-container-width: 450px;
    --painting-card-width: 414px;
    --painting-card-height: 450px;
    --painting-card-image-height: 315px;
    --painting-card-padding-x: 18px;
    --painting-card-margin-y: 18px;
    --painting-card-mask-padding: 26px 18px 16px;
    --painting-card-title-font-size: 27px;
    --painting-card-title-margin-bottom: 18px;
    --painting-card-subtitle-font-size: 23px;
    --author-card-width: 270px;
    --author-card-avatar-size: 239px;
    --author-card-margin-y: 54px;
    --author-card-name-margin-top: 10px;
    --author-card-name-font-size: 27px;
    --author-card-count-font-size: 23px;
    --index-second-content-width: 1350px;
  }
}

@media (max-width: 1280px) {
  .indexSecond-page-container {
    --painting-card-container-width: 400px;
    --painting-card-width: 368px;
    --painting-card-height: 400px;
    --painting-card-image-height: 280px;
    --painting-card-padding-x: 16px;
    --painting-card-margin-y: 16px;
    --painting-card-mask-padding: 23px 16px 14px;
    --painting-card-title-font-size: 24px;
    --painting-card-title-margin-bottom: 16px;
    --painting-card-subtitle-font-size: 20px;
    --author-card-width: 240px;
    --author-card-avatar-size: 213px;
    --author-card-margin-y: 48px;
    --author-card-name-margin-top: 9px;
    --author-card-name-font-size: 24px;
    --author-card-count-font-size: 20px;
    --index-second-content-width: 1200px;
  }
}

@media (max-width: 1100px) {
  .indexSecond-page-container {
    --painting-card-container-width: 350px;
    --painting-card-width: 322px;
    --painting-card-height: 350px;
    --painting-card-image-height: 245px;
    --painting-card-padding-x: 14px;
    --painting-card-margin-y: 14px;
    --painting-card-mask-padding: 20px 14px 13px;
    --painting-card-title-font-size: 21px;
    --painting-card-title-margin-bottom: 14px;
    --painting-card-subtitle-font-size: 18px;
    --author-card-width: 210px;
    --author-card-avatar-size: 186px;
    --author-card-margin-y: 42px;
    --author-card-name-margin-top: 8px;
    --author-card-name-font-size: 21px;
    --author-card-count-font-size: 18px;
    --index-second-content-width: 1050px;
  }
}

@media (max-width: 760px) {
  .indexSecond-page-container {
    --painting-card-container-width: 240px;
    --painting-card-width: 220px;
    --painting-card-height: 240px;
    --painting-card-image-height: 168px;
    --painting-card-padding-x: 10px;
    --painting-card-margin-y: 10px;
    --painting-card-mask-padding: 14px 10px 9px;
    --painting-card-title-font-size: 15px;
    --painting-card-title-margin-bottom: 10px;
    --painting-card-subtitle-font-size: 12px;
    --author-card-width: 144px;
    --author-card-avatar-size: 128px;
    --author-card-margin-y: 29px;
    --author-card-name-margin-top: 5px;
    --author-card-name-font-size: 14px;
    --author-card-count-font-size: 12px;
    --index-second-content-width: 720px;
  }
}
